import translations from './const/es.json';
export default {
  translation: {
    ...translations
    /*"Home": "Hogar",
    "Cases": "Casos",
    "Projects": "Proyectos",
    "Language": "Idioma",
    "User Management": "Gestión de usuarios",
    "Avatars": "Avatares",
    "Audit Trail": "Pistas de auditoría",
    "Logout": "Cerrar sesión",
    "Timeline": "Cronograma",
    "Photos": "Fotos",
    "Edit": "Editar",
    "Timeline last 12 hrs": "Cronología de las últimas 12 horas",
    "Targets": "Objetivos",
    "Success Profiles": "Perfiles de éxito",
    "Sentiment monitor": "Monitor de sentimiento",
    "Monthly statistics": "Estadísticas mensuales",
    "Full Profile": "Perfil completo",
    "Empty Profiles": "Perfiles vacíos",
    "Partional Profiles": "Perfiles parciales",
    "Link Analysis Matches": "Coincidencias de análisis de enlaces",
    "Friend Drilldown": "Desglose de amigos",
    "Profiles Deleted": "Perfiles eliminados",
    "Cases Opened": "Casos abiertos",
    "Users": "Los usuarios",
    "Active": "Vigente",
    "Archived": "Archivado",
    "Archive Investigation": "Investigación de archivo",
    "This investigation is assigned to CM test 1. Are you sure you want to archive this investigation?": "Esta investigación se asigna a la CM test 1. ¿Está seguro de que desea archivar esta investigación?",
    "Yes": "Si",
    "Cancel": "Cancelar",
    "Active cases": "Casos activos",
    "Archived cases": "Casos archivados",
    "Back": "Atrás",
    "Export": "Exportar",
    "Mentions": "Menciones",
    "Period": "Período",
    "Shared": "Compartida",
    "Audience": "Audiencia",
    "Favourites": "Favoritos",
    "Reactions": "Reacciones",
    "Target name": "Nombre del objetivo",
    "Trending": "Tendencias",
    "Map": "Mapa",
    "Monitor": "Monitor",
    "Investigation": "Investigación",
    "Alerts": "Alertas",
    "Scope": "Alcance",
    "About": "Acerca de",
    "(accounts)": "(cuentas)",
    "Clear": "Completo",
    "Username": "Nombre de usuario",
    "Edit User": "Editar usuario",
    "Password": "Contraseña",
    "Save": "Salvar",
    "Back to list": "Volver a la lista",
    "Delete User": "Borrar usuario",
    "Are you sure to delete this account": "¿Estás seguro de eliminar esta cuenta?",
    "Domain": "Dominio",
    "Login": "El login",
    "Status": "Estado",
    "Manage": "Gestionar",
    "Nr": "#",
    "Link Analysis": "Análisis de enlaces",
    "Sentiment": "Sentimiento",
    "Suspicious Targets": "Blancos sospechosos",
    "Trends": "Tendencias",
    "Update Post": "Actualizar publicación",
    "Activity": "Actividad",
    "targets": "objetivos",
    "videos": "videos",
    "matches": "partidos",
    "images": "imágenes",
    "news updates": "actualización de las noticias",
    "groups": "grupos",
    "timeline": "cronograma",
    "activity": "actividad",
    "trends": "tendencias",
    "Search": "Buscar",
    "Results": "Resultados",
    "drugs": "drogas",
    "counterfeits": "falsificaciones",
    "hacking": "hackear",
    "weapons": "armas",
    "documents": "documentos",
    "banking": "bancario",
    "digitalgoods": "bienes digitales",
    "software": "software",
    "fraud": "fraude",
    "blockchain": "blockchain",
    "prescription": "prescripción",
    "security and hosting": "seguridad y hosting",
    "tickets and bookings": "entradas y reservas",
    "services": "servicios",
    "steroids": "esteroides",
    "luxury": "lujo",
    "hardware": "hardware",
    "guides and tutorials": "guías y tutoriales",
    "Add Sentiment": "Agregar sentimiento",
    "Add": "Añadir",
    "Fake News": "Noticias falsas",
    "Cars": "Coches",
    "Video Analysis": "Análisis de video",
    "Select file to upload": "Seleccionar archivo para cargar",
    "or": "o",
    "Drag and drop video here": "Arrastra y suelta el video aquí",
    "Phrase": "Frase",
    "None": "Nada",
    "Positive": "Positivo",
    "Neutral": "Neutral",
    "Negative": "Negativo",
    "Score": "Puntuación",
    "import from CSV": "importar de CSV",
    "Search by Target ID": "Buscar por ID de destino",
    "Analysis": "Análisis",
    "Enter phone number / ID list": "Ingresar número telefónico / lista de ID",
    "Analyse": "Analizar",
    "Check": "Cheque",
    "Insert URL": "Insertar URL",
    "Car number": "Número de coche",
    "All users": "Todos los usuarios",
    "All actions": "Todas las acciones",
    "Allocate Quota": "Asignar cuota",
    "Number of requests": "Numero de solicitudes",
    "Valid From": "Válido desde",
    "Valid To": "Válido para",
    "Are you sure to delete this user": "¿Estás seguro de eliminar a este usuario",
    "Confirm Password": "Confirmar contraseña",
    "Role": "El oficio",
    "Investigations": "Investigaciones",
    "Requests": "Peticiones",
    "Quota Active": "Cuota activa",
    "Daily": "Diario",
    "Used": "Usada",
    "Quota Used": "Cuota utilizada",
    "Actions": "Comportamiento",
    "Dashboard": "Tablero",
    "Target Alerts": "Alertas de destino",
    "Scope Cases": "Alcance de casos",
    "Choose dates...": "Elige fechas ...",
    "Create investigation": "Crear investigación",
    "Add new avatar": "Añadir nuevo avatar",
    "Import": "Importar",
    "Create User": "Crear usuario",
    "Create case": "Crear caso",
    "Analyze": "Analizar",
    "History": "Historia",
    "Export to PDF": "Exportar a PDF",
    "Add target": "Añadir objetivo",
    "Edit target": "Editar objetivo",
    "Create target": "Crear objetivo",
    "Rerun": "Repetición",
    "Merge": "Unir",
    "Delete": "Eliminar",
    "Enter name": "Ingrese su nombre",
    "Enter password": "Introducir la contraseña",
    "Select domain": "Seleccionar dominio",
    "Ok": "Ok",
    "Photo": "Foto",
    "Upload": "Subir",
    "No files selected": "No hay archivos seleccionados",
    "Create Entity": "Crear entidad",
    "Keywords": "Palabras clave",
    "Video": "Video",
    "Available Avatars": "Avatares disponibles",
    "Delete Side": "Eliminar lado",
    "Configure Scope": "Configurar alcance",
    "Alert Type": "Tipo de alerta",
    "Description": "Descripción",
    "Enter text": "Ingrese texto",
    "Hashtags": "Etiquetas",
    "Blacklist hashtags": "Hashtags de lista negra",
    "Blacklist keywords": "Palabras clave de la lista negra",
    "Subcategory": "Subcategoría",
    "Upload Image": "Cargar imagen",
    "Choose file": "Elija el archivo",
    "No file chosen": "Ningún archivo elegido",
    "Return": "Volver",
    "Date": "Fecha",
    "Time": "Hora",
    "User Type": "Tipo de usuario",
    "Close": "Cerrar",
    "Prev": "Atrás",
    "Next": "Próximo",
    "Select": "Seleccione",
    "Username is required and cannot be empty": "El nombre de usuario es obligatorio y no puede estar vacío.",
    "Password is required and cannot be empty": "Se requiere contraseña y no puede estar vacía",
    "Confirm Password is required and must match the Password": "Confirme que se requiere contraseña y debe coincidir con la contraseña",
    "Administrators": "Administradores",
    "Regular users": "Usuarios habituales",
    "Role is required. Select at least one role": "Se requiere papel. Seleccione al menos un rol",
    "Statistics": "Estadísticas",
    "Social": "Social",
    "Posts": "Publicaciones",
    "Update profile": "Actualización del perfil",
    "Incremental": "Incremental",
    "Update": "Actualizar",
    "Source": "Fuente",
    "Incremental Update Profile": "Perfil de actualización incremental",
    "Delete Source": "Eliminar fuente",
    "Are you sure you want delete this source?": "¿Estás seguro de que quieres eliminar esta fuente?",
    "Map Location": "Mapa de ubicación",
    "Friends": "Amigos",
    "Full details": "Todos los detalles",
    "Main Info": "Información principal",
    "Contact Info": "Datos de contacto",
    "Preferences": "Preferencias",
    "Search Results": "Resultados de la búsqueda",
    "Synopsis": "Sinopsis",
    "Search Engine": "Buscador",
    "Link": "Enlace",
    "Preview": "Avance",
    "Published": "Publicado",
    "Analyze all": "Analiza todo",
    "Entities": "Entidades",
    "Edit Main Info": "Editar información principal",
    "Enter value": "Ingrese valor",
    "Enter phone": "Ingresar teléfono",
    "Select a country": "Seleccione un país",
    "Select all": "Seleccionar todo",
    "Delete sources": "Eliminar fuentes",
    "What are you searching for?": "¿Que estás buscando?",
    "graph": "grafico",
    "gender": "género",
    "age": "años",
    "Please enter search criteria": "Por favor, introduzca los criterios de búsqueda",
    "Choose domain": "Elegir dominio",
    "Groups": "Grupos",
    "Likes": "Gustos",
    "Comments": "Comentarios",
    "Search criteria": "Criterio de búsqueda",
    "no criteria": "sin criterios",
    "Alert ID": "ID de alerta",
    "Target ID": "ID de objetivo",
    "Content": "Contenido",
    "Alert Criteria": "Criterios de alerta",
    "Add Container": "Agregar contenedor",
    "Container Number": "Número de contenedor",
    "Please, provide container number": "Por favor, proporcione el número de contenedor",
    "Enter container code": "Ingrese el código del contenedor",
    "Container number - as XXXX1234567, where XXXX is a letters.": "Número de contenedor: como XXXX1234567, donde XXXX es una letra.",
    "Add Ship": "Agregar nave",
    "Please provide MMSI and/or IMO": "Proporcione MMSI y / o IMO",
    "Enter MMSI": "Ingrese MMSI",
    "Enter IMO": "Entra IMO",
    "Vessel name": "Nombre del buque",
    "Crew phones": "Teléfonos de la tripulación",
    "Enter phone number": "Ingresa número telefónico",
    "Delete Investigation": "Eliminar investigación",
    "Are you sure you want to delete this investigation?": "¿Estás seguro de que deseas eliminar esta investigación?",
    "Personal Information": "Informacion personal",
    "Add information manually": "Agregar información manualmente",
    "Found name(s):": "Nombre (s) encontrado (s):",
    "Friends:": "Amigos:",
    "Description:": "Descripción:",
    "Followed:": "Seguido:",
    "Address:": "Habla a:",
    "Add email": "Agregar correo electrónico",
    "Add name": "Agregar nombre",
    "Add image": "Añadir imagen",
    "Please enter a name": "Por favor ingrese un nombre",
    "Enter first and last name": "Ingrese nombre y apellido",
    "Please enter an email": "Por favor ingrese un correo electrónico",
    "Enter email": "Ingrese correo electrónico",
    "List of sources to add": "Lista de fuentes para agregar",
    "Enter social network ID": "Ingrese la identificación de la red social",
    "Daily limit cannot exceed Number of Requests": "El límite diario no puede exceder el número de solicitudes",
    "Please enter Daily limit or Number of Requests": "Ingrese el límite diario o el número de solicitudes",
    "Delete Quota": "Eliminar cuota",
    "Delete quota for user": "Delete quota for user",
    "Assigned Investigations": "Investigaciones asignadas",
    "All investigations": "Todas las investigaciones",
    "Selected investigations": "Investigaciones seleccionadas",
    "Delete Target": "Eliminar objetivo",
    "Are you sure you want to delete this target from this case?": "¿Estás seguro de que deseas eliminar este objetivo de este caso?",
    "Cruises and current location": "Cruceros y ubicación actual",
    "Create Alert": "Crear alerta",
    "Are you sure you want to delete this alert?": "¿Seguro que quieres eliminar esta alerta?",

    "Case Name is required and cannot be empty": "Case Name is required and cannot be empty",
    "Criterion": "Criterion",*/
  }
};